// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1BXuD","detailsBorder":"styles_detailsBorder__3srMu"};